'use client';

import React from 'react';
import Cart from '@/components/customercenter-ui/components/cart';

const CartTastic = ({ data }: any) => {
  return <Cart widgetData={data} />;
};

export default CartTastic;
